import React from 'react';
import TitleCard from 'components/TitleCard';
import { PanelHeader, PanelTitle, PanelWrapper } from 'components/InspectorPanel';
function StatsWrapper(_ref) {
  var _ref$isPanelLayout = _ref.isPanelLayout,
    isPanelLayout = _ref$isPanelLayout === void 0 ? false : _ref$isPanelLayout,
    title = _ref.title,
    actions = _ref.actions,
    children = _ref.children;
  if (isPanelLayout) {
    return /*#__PURE__*/React.createElement(PanelWrapper, null, /*#__PURE__*/React.createElement(PanelHeader, {
      actions: actions
    }, /*#__PURE__*/React.createElement(PanelTitle, null, title)), children);
  }
  return /*#__PURE__*/React.createElement(TitleCard, {
    title: title,
    sideContent: actions
  }, children);
}
export default StatsWrapper;